import { useMutation, useQueryClient, type QueryKey } from '@tanstack/react-query';
import { errorText } from '../lib/errors';
import { toast } from '../stores/toast';

/**
 * Мутація з типовою поведінкою: тост успіху/помилки, інвалідація ключів.
 */
export function useAction<A, R>(
  fn: (arg: A) => Promise<R>,
  opts: { invalidate?: QueryKey[]; success?: string | ((r: R, a: A) => string | null); onSuccess?: (r: R, a: A) => void; silentError?: boolean } = {},
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (r, a) => {
      for (const k of opts.invalidate ?? []) void qc.invalidateQueries({ queryKey: k });
      const msg = typeof opts.success === 'function' ? opts.success(r, a) : opts.success;
      if (msg) toast.success(msg);
      opts.onSuccess?.(r, a);
    },
    onError: (e) => {
      if (!opts.silentError) toast.error(errorText(e));
    },
  });
}
